<template>
  <div class="x-empty-content" :class="`x-empty-content--type-${type}`">
    <div class="x-empty-content--image" />
    <x-ellipsis class="x-empty-content--label" :row="1" v-if="computedLabel">
      {{ computedLabel }}
    </x-ellipsis>
  </div>
</template>
<script>
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component()
export default class EmptyContent extends Vue {
  @Prop({ type: String }) label;
  get computedLabel() {
    return this.label == null
      ? this.$t('common.label.emptyContent')
      : this.label;
  }
  /**
   * @name 空态图类型
   * 默认	default
   * 主页	home
   * 列表	list
   * 搜索	search
   */
  @Prop({ type: String, default: 'default' }) type;
}
</script>
<style lang="less">
.x-empty-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.x-empty-content--image {
  width: 80%;
  height: 200px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.x-empty-content--type-default .x-empty-content--image {
  background-image: var(--empty-image);
}
.x-empty-content--type-home .x-empty-content--image {
  background-image: var(--empty-home-image);
}
.x-empty-content--type-list .x-empty-content--image {
  background-image: var(--empty-list-image);
}
.x-empty-content--type-search .x-empty-content--image {
  background-image: var(--empty-search-image);
}
.x-empty-content--label {
  margin-top: 5px;
  margin-left: 10px;
  font-size: 16px;
  color: var(--font-info);
  display: inline-block;
}
</style>
